// extracted by mini-css-extract-plugin
export var buttonContent = "_25-0";
export var centered = "_25-1";
export var centeredFlex = "_25-2";
export var errorText = "_25-3";
export var icon = "_25-4";
export var iconButtonContent = "_25-5";
export var monospace = "_25-6";
export var padded = "_25-7";